<footer class="footer-container">
  <div class="footer-content">
    <div class="footer-main">
      <div class="footer-left">
        <div class="footer-logo">
          <img
            [src]="footerData.logo"
            alt="Seychelles Islands"
            width="216"
            height="160"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div class="social-links">
          <a
            *ngFor="let social of footerData.socialLinks"
            [href]="social.url"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="social.label"
            class="social-icon"
          >
            <img [src]="social.iconUrl" [alt]="social.label" width="39" height="39" loading="lazy" decoding="async" />
          </a>
        </div>
      </div>

      <div class="footer-links">
        <div class="footer-column">
          <h3 role="heading" aria-level="2">{{ footerData.aboutSection.title }}</h3>
          <ul>
            <li *ngFor="let link of footerData.aboutSection.links">
              <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                {{ link.text }}
              </a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 role="heading" aria-level="2">{{ footerData.otherSection.title }}</h3>
          <ul>
            <li *ngFor="let link of footerData.otherSection.links">
              <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                {{ link.text }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="language-selector-container">
          <app-new-language-selector></app-new-language-selector>
        </div>

        <div class="disclaimer">
          <p>{{ footerData.disclaimer }}</p>
        </div>
      </div>

      <div class="copyright">
        <p>
          {{ 'All rights reserved.' | translate }} {{ footerData.copyright }} {{ 'The Seychelles Islands' | translate }}
        </p>
      </div>
    </div>
  </div>
</footer>
